<div class="flex gap-2 justify-end">
  @if (!params.isEditing()) {
    <app-pan-button color="primary" (click)="params.editEnable()" data-testid="edit"> Edit </app-pan-button>
  } @else {
    <app-pan-button
      class="mr-1"
      color="warning"
      [state]="params.isSaving() ? 'loading' : 'default'"
      [disabled]="params.isSaving()"
      (click)="params.editCancel()"
    >
      Cancel
    </app-pan-button>

    <app-pan-button
      color="primary"
      [state]="params.isSaving() ? 'loading' : 'default'"
      [disabled]="params.isSaving()"
      (click)="params.editSave()"
    >
      Save
    </app-pan-button>
  }
</div>
